export const reachedMaxCapacity = (
  availableCapacity: number | null | undefined,
  requiredCapacity: number | null | undefined
) => {
  if (!requiredCapacity) return undefined;
  const capacity = availableCapacity ?? 0;

  return capacity < requiredCapacity;
};
